import { Box, Button, Typography, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { BsThreeDots } from "react-icons/bs";
import { HiCheck } from "react-icons/hi";
import { PALETTE } from "../Theme/Palette";

function Stepper({ steps, onChange }) {
  return (
    <Box borderBottom={`1px solid ${PALETTE.secondary}`} mb="3.5rem" pb={2}>
      <Box
        display="flex"
        flexDirection="row-reverse"
        justifyContent="space-between"
        sx={{
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",
          overflowY: "hidden",
          whiteSpace: "nowrap",
        }}
      >
        {steps.map((step, index) => (
          <Tooltip
            key={index}
            title={step.errors}
            describeChild
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  color: "#4C466F",
                  fontSize: "1rem",
                  bgcolor: "#FAFAFA",
                  direction: "rtl",
                  "& .MuiTooltip-arrow": {
                    color: "#FAFAFA",
                  },
                },
              },
            }}
          >
            <Button
              key={step.route}
              style={{ display: "inline-block", minWidth: "140px", flex: 1 }}
              onClick={() => {
                onChange(step);
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <span
                  style={{
                    display: "flex",
                    borderRadius: "50%",
                    backgroundColor:
                      step.status === "active" || step.status === "complete"
                        ? "#0EE8B6"
                        : step.status === "error"
                        ? "#FFB84D"
                        : "#EEEEEE",
                    width: "22px",
                    height: "22px",
                    margin: "0.4rem auto 1rem",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {(step.status === "active" || step.status === "error") && (
                    <BsThreeDots color="#FFFFFF" fontSize="1.1rem" letterSpacing="0px" />
                  )}
                  {step.status === "complete" && <HiCheck color="#FFFFFF" fontSize="1.1rem" />}
                </span>
                <Typography
                  fontWeight="bold"
                  sx={{ color: PALETTE.secondary, textAlign: "center" }}
                >
                  {step.label}
                </Typography>
              </Box>
            </Button>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
}

Stepper.propTypes = {
  onChange: PropTypes.func,
};

export default Stepper;
